<template>
  <div>
    <b-nav class="my-3 font-weight-bold" tabs pills>
      <b-nav-item
        @click="activeTab = 'products'"
        :active="activeTab === 'products'"
      >
        Theo sản phẩm
        <b-badge variant="primary" class="ml-2">
          {{ productCount }}
        </b-badge>
      </b-nav-item>

      <b-nav-item
        @click="activeTab = 'categories'"
        :active="activeTab === 'categories'"
      >
        Theo danh mục
        <b-badge variant="primary" class="ml-2">
          {{ categoryCount }}
        </b-badge>
      </b-nav-item>
    </b-nav>

    <!-- Tab Sản phẩm -->
    <div v-if="activeTab === 'products'">
      <b-row>
        <b-form-group class="col-md-12 pr-0">
          <label>Tìm sản phẩm:</label>
          <b-col class="row pr-0">
            <b-col md="6" class="p-0">
              <Autosuggest
                :model="searchProductFor"
                :suggestions="optionProducts"
                :placeholder="'Tìm theo tên, mã, mã vạch sản phẩm để thêm vào chương trình'"
                :limit="10"
                @select="onSelectedProductFor"
                @change="onInputChangeProductFor"
                :disabled="false"
                suggestionName="productName"
              />
            </b-col>
            <b-col md="2" class="p-0">
              <b-form-select
                class="select-style border-left-0 rounded-left-0 rounded-right-0"
                v-model="selectTypeSearchFor"
                :options="[
                  {
                    id: 1,
                    name: 'Sản phẩm IMEI',
                  },
                  {
                    id: 2,
                    name: 'Sản phẩm',
                  },
                ]"
                size="sm"
                value-field="id"
                text-field="name"
                disabled-field="notEnabled"
                @change="debounceInputFor"
              ></b-form-select>
            </b-col>
            <b-col md="2" class="p-0">
              <b-form-select
                class="select-style border-left-0 rounded-left-0"
                v-model="selectTypeOfProductFor"
                :options="productTypes"
                size="sm"
                value-field="id"
                text-field="name"
                disabled-field="notEnabled"
                @change="debounceInputFor"
              ></b-form-select>
            </b-col>
            <b-col md="2" class="pr-0" v-if="false">
              <div class="d-flex justify-content-end">
                <button
                  type="button"
                  class="btn btn-secondary font-weight-bolder btn-sm"
                  @click="showModalImportProductFor"
                >
                  <i style="font-size: 1rem" class="far fa-file-excel"></i>
                  Nhập từ excel
                </button>
              </div>
            </b-col>
          </b-col>
        </b-form-group>
      </b-row>
      <b-row>
        <b-col md="12">
          <div>
            <DealSheetDetailTable
              :fields="productFields"
              :items="productItems"
              :current-page.sync="currentPageProductTable"
              type="product"
              :main-model="mainModel"
              @show-imei-modal="handleShowImeiModal"
              @change-target-type="onChangeTargetType"
              @change-discount-type="onChangeDiscountType"
              @change-discount-policy-type="onChangeDiscountPolicyType"
              @delete-item="handleDeleteItem"
            />
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Tab Danh mục -->
    <div v-if="activeTab === 'categories'">
      <b-row>
        <b-form-group class="col-md-12 pr-0">
          <label>Tìm danh mục:</label>
          <b-col class="row pr-0">
            <b-col md="6" class="p-0">
              <treeselect
                :value="selectedCategory"
                @input="updateSelectedCategory"
                :options="categories"
                :normalizer="normalizeCategory"
                :multiple="true"
                :flat="false"
                :placeholder="'Tìm theo tên danh mục để thêm vào chương trình'"
                :disable-branch-nodes="false"
                :show-count="true"
                :searchable="true"
                :clearable="true"
                noResultsText="Không tìm thấy kết quả"
              />
            </b-col>
          </b-col>
        </b-form-group>
      </b-row>
      <b-row>
        <b-col md="12">
          <div>
            <DealSheetDetailTable
              :fields="categoryFields"
              :items="categoryItems"
              :current-page.sync="currentPageCategoryTable"
              type="category"
              :main-model="mainModel"
              @show-imei-modal="handleShowImeiModal"
              @change-target-type="onChangeTargetType"
              @change-discount-type="onChangeDiscountType"
              @change-discount-policy-type="onChangeDiscountPolicyType"
              @delete-item="handleDeleteItem"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <DealSheetImeiReportModal ref="imeiModal" />
  </div>
</template>

<script>
import { AMOUNT_TYPE, TARGET_TYPE, DISCOUNT_POLICY_TYPE } from '@/utils/enum';
import { convertPrice, unMaskPrice, makeToastFaile } from '@/utils/common';
import { showDeleteAlert } from '@/utils/sweet-alert2';
import {
  PRODUCT_TABLE_FIELDS,
  CATEGORY_TABLE_FIELDS,
} from '@/view/pages/dealsheets/utils/tableConfig';
import { PRODUCT_RELATIONSHIP_TYPES } from '@/utils/constants';
import { normalizeCategory } from '@/utils/normalize-category';
import { searchProducts } from '@/view/pages/dealsheets/utils/apiHelpers';
import { TIME_TRIGGER } from '@/utils/constants';
import debounce from 'debounce';
import { cloneDeep } from 'lodash';
import { v4 } from 'uuid';
import _ from 'lodash';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import DealSheetImeiReportModal from './DealSheetImeiReportModal.vue';
import DealSheetDetailTable from './DealSheetDetailTable.vue';

export default {
  name: 'DealSheetDetails',
  props: {
    dealsheetDetails: {
      type: Array,
      default: () => [],
    },
    selectedCategory: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    mainModel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      AMOUNT_TYPE,
      TARGET_TYPE,
      normalizeCategory,
      modalDesc: 'Bạn có muốn xoá',
      modalTitle: 'Xoá ',
      productFields: PRODUCT_TABLE_FIELDS,
      categoryFields: CATEGORY_TABLE_FIELDS,
      filteredProducts: [],
      searchProductFor: '',
      isSearching: false,
      productTypes: PRODUCT_RELATIONSHIP_TYPES,
      selectTypeSearchFor: 2,
      selectTypeOfProductFor: 0,
      currentPageProductTable: 1,
      currentPageCategoryTable: 1,
      localDealsheetDetails: [],
      isSyncingFromProps: false,
      activeTab: 'products',
    };
  },
  computed: {
    optionProducts() {
      return [...cloneDeep(this.filteredProducts)];
    },
    productItems() {
      return this.localDealsheetDetails.filter((item) => item.productId);
    },
    categoryItems() {
      return this.localDealsheetDetails.filter(
        (item) => item.categoryId && !item.productId,
      );
    },
    productCount() {
      return this.productItems.length;
    },
    categoryCount() {
      return this.categoryItems.length;
    },
  },
  watch: {
    dealsheetDetails: {
      handler(newVal) {
        const newValStr = JSON.stringify(newVal);
        const currentValStr = JSON.stringify(this.localDealsheetDetails);
        if (newValStr !== currentValStr) {
          this.isSyncingFromProps = true;
          this.localDealsheetDetails = cloneDeep(newVal);
          this.$nextTick(() => {
            this.isSyncingFromProps = false;
            this.updateCounts();
          });
        }
      },
      immediate: true,
      deep: true,
    },
    localDealsheetDetails: {
      handler(newVal) {
        if (!this.isSyncingFromProps) {
          this.$emit('update:dealsheetDetails', cloneDeep(newVal));
        }
      },
      deep: true,
    },
    selectedCategory: {
      handler(newVal, oldVal) {
        if (!oldVal) oldVal = [];

        const addedCategories = newVal.filter(
          (catId) => !oldVal.includes(catId),
        );

        const removedCategories = oldVal.filter(
          (catId) => !newVal.includes(catId),
        );

        addedCategories.forEach((categoryId) => {
          const category = this.findCategoryById(categoryId);
          if (category) {
            const index = this.localDealsheetDetails.findIndex(
              (item) => item.categoryId === categoryId && !item.productId,
            );
            if (index === -1) {
              this.localDealsheetDetails.unshift({
                id: v4(),
                productId: null,
                categoryId: categoryId,
                categoryName: category.name || category.label || '',
                productName: category.name || category.label || '',
                productCode: '',
                targetQuantity: 0,
                targetType: TARGET_TYPE.QUANTITY,
                discountAmount: 0,
                discountType: AMOUNT_TYPE.PERCENT,
                discountPolicyType: DISCOUNT_POLICY_TYPE.SALE_OUT,
                originalPrice: 0,
                alias: '',
                count: 0,
              });
            }
          }
        });

        removedCategories.forEach((categoryId) => {
          this.localDealsheetDetails = this.localDealsheetDetails.filter(
            (item) => !(item.categoryId === categoryId && !item.productId),
          );
        });

        this.updateCounts();
      },
      deep: true,
    },
  },
  components: {
    Treeselect,
    Autosuggest,
    DealSheetImeiReportModal,
    DealSheetDetailTable,
  },
  methods: {
    showDeleteAlert,
    convertPrice,
    updateSelectedCategory(value) {
      this.$emit('update:selectedCategory', value);
    },
    async fetchProduct(textSearch) {
      this.isSearching = true;
      this.filteredProducts = await searchProducts(
        textSearch,
        this.selectTypeSearchFor,
        this.selectTypeOfProductFor,
      );
      this.isSearching = false;
    },
    debounceInputFor: debounce(function () {
      if (!this.isSearching) {
        let textSearch = this.searchProductFor;
        this.fetchProduct(textSearch);
      }
    }, TIME_TRIGGER),
    onSelectedProductFor(option) {
      this.searchProductFor = '';
      const index = this.localDealsheetDetails.findIndex((item) => {
        return item.productId == option.item.productId;
      });
      if (index > -1) {
        return makeToastFaile(`${option.item.productName} đã tồn tại`);
      }
      const categoryId =
        this.selectedCategory && this.selectedCategory.length > 0
          ? this.selectedCategory[0]
          : null;

      this.localDealsheetDetails.unshift({
        id: v4(),
        productId: option.item.productId,
        targetQuantity: unMaskPrice(option.item.targetQuantity) || 0,
        targetType: option.item.targetType || TARGET_TYPE.QUANTITY,
        discountAmount: unMaskPrice(option.item.discountAmount) || 0,
        discountType: option.item.discountType,
        discountPolicyType:
          option.item.discountPolicyType || DISCOUNT_POLICY_TYPE.SALE_OUT,
        productName: option.item.productName,
        productCode: option.item.productCode,
        alias: option.item?.alias || '',
        originalPrice: option.item.originalPrice,
        categoryId: categoryId,
        categoryName: option.item?.categoryName || '',
        count: 0,
      });
      this.updateCounts();
    },
    onInputChangeProductFor(text) {
      this.searchProductFor = text;
      this.debounceInputFor();
    },
    confirmDeleteProduct(deleteItem) {
      if (deleteItem.productId) {
        this.localDealsheetDetails = _.reject(
          this.localDealsheetDetails,
          (item) => {
            return item.productId == deleteItem.productId;
          },
        );
      } else if (deleteItem.categoryId) {
        this.localDealsheetDetails = _.reject(
          this.localDealsheetDetails,
          (item) => {
            return item.categoryId == deleteItem.categoryId && !item.productId;
          },
        );
        const newSelectedCategory = this.selectedCategory.filter(
          (catId) => catId !== deleteItem.categoryId,
        );
        this.$emit('update:selectedCategory', newSelectedCategory);
      }
      this.updateCounts();
    },
    onChangeDiscountType(productItem, discountType) {
      productItem.discountType = discountType;
    },
    onChangeTargetType(productItem, targetType) {
      productItem.targetType = targetType;
    },
    onChangeDiscountPolicyType(productItem, discountPolicyType) {
      productItem.discountPolicyType = discountPolicyType;
    },
    findCategoryById(categoryId) {
      const findInTree = (nodes) => {
        for (const node of nodes) {
          if (node.id === categoryId) {
            return node;
          }
          if (node.children && node.children.length > 0) {
            const found = findInTree(node.children);
            if (found) return found;
          }
        }
        return null;
      };
      return findInTree(this.categories);
    },
    showModalImportProductFor() {},
    updateCounts() {
      this.productItems.forEach((element, index) => {
        element.count = index + 1;
      });
      this.categoryItems.forEach((element, index) => {
        element.count = index + 1;
      });
    },
    handleShowImeiModal(dealSheetDetail) {
      this.$refs.imeiModal.showModal(dealSheetDetail, {
        dealSheetCode: this.mainModel?.code,
      });
    },
    handleDeleteItem(item, itemType) {
      showDeleteAlert(
        `${this.modalTitle} ${itemType}!`,
        `${this.modalDesc} ${itemType} ${
          item.productName || item.categoryName
        } `,
        item,
        this.confirmDeleteProduct,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .table {
    th,
    td {
      padding: 0.75rem;
      vertical-align: middle;
      border-top: 1px solid #ecf0f3;
    }
  }
}
</style>
